import { render } from "./trainDetail.vue?vue&type=template&id=3e7fb050&scoped=true"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"

import "./trainDetail.vue?vue&type=style&index=0&id=3e7fb050&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7fb050"]])

export default __exports__